/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_View_AllInputs */

const en_notifications_view_all = /** @type {(inputs: Notifications_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all`)
};

const pl_notifications_view_all = /** @type {(inputs: Notifications_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz wszystkie`)
};

/**
* | output |
* | --- |
* | "View all" |
*
* @param {Notifications_View_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_view_all = /** @type {((inputs?: Notifications_View_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_View_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_view_all(inputs)
	return en_notifications_view_all(inputs)
});